import React from 'react';
import HackathonProjects from '../components/HackathonProjects';
import HardwareProjects from '../components/HardwareProjects';

const Projects = () => {
  return (
    <div>
      <HackathonProjects />
      <HardwareProjects />
    </div>
  );
};

export default Projects;

